import { breadcrumbsContent } from "../breadcrumbs/BreadcrumbsContent";
import Button from "../buttons/Button";
import SecondaryButton from "../buttons/SecondaryButton";
import TertiaryButton from "../buttons/TertiaryButton";
import useTranslation from "../CustomHooks/useTranslation";

interface AddBottomButton {
  buttonClass?: string;
  buttonName: string;
  onClick: () => void;
  loading: boolean;
  testID?: string;
  disabled?: boolean;
  buttonWidth?: string;
  secondaryButtonName?: string;
  secondaryButtonClass?: string;
  secondaryButtonFunction?: () => void | undefined;
  tertiaryButtonName?: string;
  tertiaryButtonFunction?: () => void | undefined;
  tertiaryButtonClass?: string;
}
export default function AddBottomButton({
  buttonClass,
  buttonName,
  testID,
  disabled,
  loading,
  onClick,
  buttonWidth,
  secondaryButtonName,
  secondaryButtonFunction,
  secondaryButtonClass,
  tertiaryButtonName,
  tertiaryButtonFunction,
  tertiaryButtonClass
}: AddBottomButton) {
  const { translate, notEnglish } = useTranslation(breadcrumbsContent)
  return (
    <div className="bg-white m-3 px-6 py-[15px] rounded-lg flex justify-between z-[999] items-center" dir={notEnglish ? 'rtl' : 'ltr'}>
      <div className="flex gap-2">
        {secondaryButtonName && (
          <SecondaryButton
            buttonName={secondaryButtonName}
            className={secondaryButtonClass}
            handleClick={secondaryButtonFunction}
            testId={`${secondaryButtonName.toLowerCase()}-button`}
          />
        )}
        <Button
          loading={loading}
          buttonName={translate(buttonName)}
          buttonType
          buttonWidth={`${buttonWidth ? buttonWidth : ' w-[223px]'}`}
          className={`${buttonClass}`}
          buttonHight="h-[45px]"
          textSize="text-small"
          buttonOnclick={onClick}
          testId={testID}
          buttonDisabled={disabled}
        />
      </div>
      {tertiaryButtonName && <TertiaryButton
        id={tertiaryButtonName.toLowerCase()}
        buttonName={tertiaryButtonName}
        handleClick={tertiaryButtonFunction}
        className={`${tertiaryButtonClass}`}
        testId={`${tertiaryButtonName.toLowerCase()}`}
      />}
    </div>
  );
}
